"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrCatch = void 0;
function getOrCatch(getValue) {
    try {
        const value = getValue();
        if (value instanceof Promise) {
            return value.then((value) => ({ value })).catch((error) => ({ error }));
        }
        else {
            return { value };
        }
    }
    catch (error) {
        return { error };
    }
}
exports.getOrCatch = getOrCatch;
//# sourceMappingURL=getOrCatch.js.map